//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogAddPickPoint: () => import('../DialogAddPickPoint/index.vue'),
    DialogEditPickPoint: () => import('../DialogEditPickPoint/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      editDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteRow: function (row) {
      let data = {id: row.pointId}
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/dealer/pick/point/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    }
  }
}
